import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { waitFor } from './utils';
import { delayTime, DEFAULT_DELAY } from './constants';
import tiktok from './tiktok/tiktok';
import fullstory from './fullstory/fullstory';
import quora from './quora/quora';
import facebook from './facebook/facebook';
import linkedin from './linkedin/linkedin';
import userleap from './userleap/index';
import trustpilot from './trustpilot/index';
import { onLoad } from '~/utils/onLoad';
var debug = function debug(message) {
  // eslint-disable-next-line
  if (!process.env.isProduction) console.log(message);
};
/**
 * As a big application we use many 3rd party scripts
 * But that affects our performance as well
 * That Plugin:
 * - loads scripts with delay on app load;
 * - inject scripts object to ctx.$3rdParty (eg $3rdParty.facebook);
 * - provides immediately load as a promise;
 *
 * Every script should be prepared for plugin:
 * 1. Better to separate script for 2 parts:
 *    - setup: with queue and object initialization to have earliest access to script as possible;
 *    - load: loading/injection of a script; If script only have load function that's ok.
 * 2. Patch load function:
 *    We must provide onLoad/onError callback to injection (see any implemented script)
 * 3. If script starts to load dependencies you must provide isInitialized Promise, which must check
 *    for some initialize properties of script in a loop.
 * 4. Return functions above
 */
export default (function (ctx, inject) {
  var scripts = _objectSpread({
    tiktok: tiktok(ctx),
    facebook: facebook(ctx),
    quora: quora(ctx),
    userleap: userleap(ctx),
    linkedin: linkedin(ctx),
    trustpilot: trustpilot(ctx)
  }, process.env.isProduction && {
    fullstory: fullstory(ctx)
  });

  /**
   * Load all 3rd party scripts with delay on application start
   */
  var loadAllWithDelay = function loadAllWithDelay() {
    Object.entries(scripts).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        script = _ref2[1];
      var delay = delayTime[name] || DEFAULT_DELAY;
      onLoad(function () {
        if (!script || script.isLoaded === true) return;
        script.isLoaded = true;
        script.load().then(function () {
          debug("Script '".concat(name, "' loaded with delay"));
        }).catch(function () {
          debug("Script '".concat(name, "' fails with delay"));
        });
      }, delay);
    });
  };
  loadAllWithDelay();

  /**
   * Load scripts immediately
   */
  var loadImmediately = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(scriptName) {
      var timeout,
        scriptNames,
        scriptsForLoad,
        startTime,
        scriptsForInitialize,
        restTimeout,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            timeout = _args.length > 1 && _args[1] !== undefined ? _args[1] : 3000;
            scriptNames = Array.isArray(scriptName) ? scriptName : [scriptName]; // 1. Load scripts with pathched onLoad/onError
            //    Some scripts could fail because of adblock or network
            scriptsForLoad = scriptNames.map(function (name) {
              var script = scripts[name];
              if (script !== null && script !== void 0 && script.isLoaded) return null;
              return script.load().then(function () {
                debug("Script '".concat(name, "' starts loading immediately"));
                script.isLoaded = true;
              }).catch(function () {
                debug("Script '".concat(name, "' fails"));
                script.isError = true;
              });
            }); // 2. Wait until complete of p.1 + timeout limit
            //    We can't wait forever in case if some script won't load
            startTime = performance.now();
            _context.next = 6;
            return Promise.race([Promise.all(scriptsForLoad), waitFor(timeout)]);
          case 6:
            // 3. Check properties of initialized script
            //    Some scripts could start to fetch dependencies, check inner state
            //    of initialiation. In most cases it could be overwhelm.
            scriptsForInitialize = scriptNames.map(function (name) {
              var script = scripts[name];
              if (script !== null && script !== void 0 && script.isError) return null;
              if (!(script !== null && script !== void 0 && script.isInitialized)) {
                debug("Script '".concat(name, "' doesn't have init checker, perhaps loaded"));
                return null;
              }
              return script.isInitialized().then(function () {
                debug("Script '".concat(name, "' loaded immediately"));
              });
            }); // 4. Wait until complete p.3 + timeout
            restTimeout = timeout - (performance.now() - startTime);
            _context.next = 10;
            return Promise.race([Promise.all(scriptsForInitialize), waitFor(restTimeout)]);
          case 10:
            _context.next = 12;
            return waitFor(200);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadImmediately(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * Collect all entries for scripts and inject by name
   */
  var scriptEntries = Object.entries(scripts).reduce(function (entries, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      name = _ref5[0],
      script = _ref5[1];
    if (script !== null && script !== void 0 && script.entry) entries[name] = script.entry;
    return entries;
  }, {});
  inject('3rdParty', _objectSpread({
    loadImmediately: loadImmediately
  }, scriptEntries));
});